<template>
  <td
    :class="
      value && value.comment === '+1'
        ? 'success'
        : value.comment === '-1'
        ? 'error'
        : ''
    "
  >
    <v-btn text block @click="update" v-if="!disabled">
      {{ value.comment || "–" }}
    </v-btn>
    <div class="text-center" v-else>{{ value.comment || "–" }}</div>
  </td>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: ["day", "time", "value", "wishId", "disabled"],
  name: "WishItem",
  data() {
    return { items: [null, "-1", "+1"] };
  },

  computed: {},
  methods: {
    async update() {
      const newValue =
        this.items[
          (this.items.indexOf(this.value.comment) + 1) % this.items.length
        ];
      if (!newValue) {
        if (this.value.id > 0) {
          await this.apiDelete({
            resource: "teacher/wishslot",
            id: this.value.id,
          });
          this.$emit("update", newValue);
        }
        return;
      }
      await this.apiSave({
        resource: "teacher/wishslot",
        add: this.value.id === 0,
        data: {
          id: this.value.id,
          wish: this.wishId,
          time: this.time,
          day: this.day,
          comment: newValue,
          forced: false,
        },
      });
      this.$emit("update", newValue);
    },
  },
  created() {},
});
</script>
